import(/* webpackMode: "eager", webpackExports: ["MainNav"] */ "/vercel/path0/components/main-nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DocsSidebarNav"] */ "/vercel/path0/components/sidebar-nav.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
